import routerOptions0 from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/node_modules/.pnpm/nuxt@3.10.0_@parcel+watcher_0460c02684e6e9175205b127107916c4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}